import { useMemo } from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip as LTooltip } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'leaflet/dist/leaflet.css';
import { Paper, Stack, Switch, Typography } from '@mui/material';

const PALERMO = [38.13, 13.34];

export default function MapView({ items, onOpen, setMap, cluster, setCluster, userPos, height }) {
  const markers = useMemo(() => items
    .filter(({ raw }) => Number.isFinite(raw.latitude) && Number.isFinite(raw.longitude))
    .map(({ raw, meta }) => (
    <CircleMarker
      key={raw.id}
      center={[raw.latitude, raw.longitude]}
      radius={9}
      pathOptions={{
        color: meta.stato === 'revisionato' ? '#15803d' : '#ea580c',
        fillColor: meta.stato === 'revisionato' ? '#22c55e' : '#fb923c',
        fillOpacity: 0.85, weight: 2,
      }}
      eventHandlers={{ click: () => onOpen(raw.id) }}
    >
      <LTooltip direction="top" offset={[0, -6]}>{raw.title || `id ${raw.id}`}</LTooltip>
    </CircleMarker>
  )), [items, onOpen]);

  return (
    <div style={{ position: 'relative', height }}>
      <MapContainer ref={setMap} center={PALERMO} zoom={12} style={{ height: '100%', width: '100%' }} scrollWheelZoom>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {cluster
          ? <MarkerClusterGroup chunkedLoading maxClusterRadius={45}>{markers}</MarkerClusterGroup>
          : markers}
        {userPos && (
          <CircleMarker center={[userPos.lat, userPos.lon]} radius={8}
                        pathOptions={{ color: '#ffffff', fillColor: '#1d4ed8', fillOpacity: 1, weight: 3 }}>
            <LTooltip direction="top" offset={[0, -6]}>Sei qui</LTooltip>
          </CircleMarker>
        )}
      </MapContainer>
      <Paper sx={{ position: 'absolute', left: 10, bottom: 24, zIndex: 1000, px: 1.2, py: 0.3 }}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>Cluster</Typography>
          <Switch size="small" checked={cluster} onChange={(e) => setCluster(e.target.checked)} />
        </Stack>
      </Paper>
    </div>
  );
}
